import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaBoxes, FaShoppingCart, FaStore, FaStar, FaMoon, FaSun, FaBars, FaTimes } from 'react-icons/fa';
import AppContext from '../contexts/AppContext';
import ThemeContext from '../contexts/ThemeContext';
import navlogo from '../assets/Navlogo.png';

const Navbar = () => {
  const location = useLocation();
  const { totalCount } = useContext(AppContext);
  const { isDark, toggleTheme } = useContext(ThemeContext);

  return (
    <nav
      className={`navbar navbar-expand-lg sticky-top shadow-sm ${isDark ? 'navbar-dark bg-dark border-bottom border-secondary' : 'navbar-light bg-white'
        }`}
    >
      <div className="container-fluid px-4">
        {/* Brand Logo */}
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img
            src={navlogo}
            alt="AK Crackers Logo"
            style={{
              width: "50px",
              height: "50px",
              objectFit: "contain",
              marginRight: "10px"
            }}
          />
          <span>AK Crackers</span>
        </Link>

        {/* Toggle Button - Setup for Mobile offcanvas trigger target */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#akOffcanvasMenu"
          aria-controls="akOffcanvasMenu"
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/* 1. LAPTOP/DESKTOP VIEW: Regular Bootstrap navbar engine wrapper */}
        <div className="collapse navbar-collapse d-none d-lg-flex" id="akNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-2">
            <li className="nav-item">
              <Link className={`nav-link d-flex align-items-center gap-2 ${location.pathname === '/' ? 'active' : ''}`} to="/">
                <FaHome size={16} /> Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link d-flex align-items-center gap-2 ${location.pathname === '/reviews' ? 'active' : ''}`} to="/reviews">
                <FaStar size={16} /> Reviews
              </Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link d-flex align-items-center gap-2 position-relative ${location.pathname === '/cart' ? 'active' : ''}`} to="/cart">
                <FaShoppingCart size={16} /> Cart
                {totalCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {totalCount}
                  </span>
                )}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="btn btn-danger btn-sm ms-lg-2 d-flex align-items-center gap-2" to="/products">
                <FaStore size={16} /> Shop Now
              </Link>
            </li>
            <li className="nav-item">
              <button className={`btn btn-outline-secondary btn-sm d-flex align-items-center gap-2 ${isDark ? 'text-light' : ''}`} onClick={toggleTheme}>
                {isDark ? <FaSun size={16} /> : <FaMoon size={16} />}
                <span>{isDark ? 'Light' : 'Dark'}</span>
              </button>
            </li>
          </ul>
        </div>

        {/* 2. MOBILE VIEW ONLY: Sliding Offcanvas Side Menu Layer */}
        <div 
          className={`offcanvas offcanvas-start d-lg-none ${isDark ? 'bg-dark text-white' : 'bg-white text-dark'}`} 
          id="akOffcanvasMenu"
          tabIndex="-1"
          style={{ maxWidth: "280px" }}
        >
          {/* Mobile Side Menu Header with Close Trigger Button */}
          <div className="offcanvas-header border-bottom py-3 px-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <img src={navlogo} alt="AK Logo" style={{ width: "35px", height: "35px", marginRight: "8px" }} />
              <span className="fw-bold h6 m-0">AK Crackers Menu</span>
            </div>
            <button type="button" className={`btn-close ${isDark ? 'btn-close-white' : ''}`} data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>

          {/* Mobile Side Menu List body elements */}
          <div className="offcanvas-body p-4">
            <ul className="navbar-nav d-flex flex-column gap-3">
              <li className="nav-item" data-bs-dismiss="offcanvas">
                <Link className={`nav-link d-flex align-items-center gap-2 py-1 ${location.pathname === '/' ? 'active fw-bold' : ''}`} to="/">
                  <FaHome size={18} /> Home
                </Link>
              </li>
              <li className="nav-item" data-bs-dismiss="offcanvas">
                <Link className={`nav-link d-flex align-items-center gap-2 py-1 ${location.pathname === '/reviews' ? 'active fw-bold' : ''}`} to="/reviews">
                  <FaStar size={18} /> Reviews
                </Link>
              </li>
              <li className="nav-item" data-bs-dismiss="offcanvas">
                <Link className={`nav-link d-flex align-items-center gap-2 py-1 ${location.pathname === '/cart' ? 'active fw-bold' : ''}`} to="/cart">
                  <FaShoppingCart size={18} /> Cart
                  {totalCount > 0 && (
                    <span className="badge rounded-pill bg-danger ms-2">
                      {totalCount}
                    </span>
                  )}
                </Link>
              </li>
              <li className="nav-item pt-2" data-bs-dismiss="offcanvas">
                <Link className="btn btn-danger w-100 d-flex align-items-center justify-content-center gap-2 py-2" to="/products">
                  <FaStore size={18} /> Shop Now
                </Link>
              </li>
              <li className="nav-item pt-2">
                <button className={`btn w-100 d-flex align-items-center justify-content-center gap-2 py-2 ${isDark ? 'btn-outline-light' : 'btn-outline-dark'}`} onClick={toggleTheme}>
                  {isDark ? <FaSun size={16} /> : <FaMoon size={16} />}
                  <span>{isDark ? 'Light Mode' : 'Dark Mode'}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;